"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const components_1 = require("@bimser/components");
const __1 = require("../..");
const helpers_1 = require("../../helpers");
const PrimitiveListItemTemplate = (props) => {
    const renderText = () => {
        var _a;
        const subType = ((_a = props.externalProps) === null || _a === void 0 ? void 0 : _a.getSubType)
            ? props.externalProps.getSubType(props.externalData)
            : 1 /* Plugins.QueryDesigner.Enums.EParameterValueTypes.String */;
        const formattedDisplay = (0, helpers_1.getFormattedDisplay)(subType, props.externalData.value);
        return formattedDisplay ? (0, jsx_runtime_1.jsx)("h3", { children: formattedDisplay }) : (0, jsx_runtime_1.jsx)("h3", { children: props.text });
    };
    return ((0, jsx_runtime_1.jsx)(components_1.BCListEditorItemTemplate, Object.assign({}, props, { renderCustomListItemText: renderText })));
};
exports.default = PrimitiveListItemTemplate;
//# sourceMappingURL=PrimitiveArrayItemTemplate.js.map